import { FLAT_QUESTIONS } from './flat-questions.js';
import { FORCAS_META, type ForcaMeta } from './forcas-meta.js';

export type TemaDef = { nome: string; qs: readonly string[] };
export type ForcaDef = Omit<ForcaMeta, 'temaNames'> & { temas: readonly [TemaDef, TemaDef] };

function buildForcas(): ForcaDef[] {
  return FORCAS_META.map((m, fi) => {
    const t0: string[] = [];
    const t1: string[] = [];
    for (let qi = 0; qi < 5; qi++) {
      t0.push(FLAT_QUESTIONS[fi * 10 + 0 * 5 + qi]!);
      t1.push(FLAT_QUESTIONS[fi * 10 + 1 * 5 + qi]!);
    }
    const temas: [TemaDef, TemaDef] = [
      { nome: m.temaNames[0], qs: t0 },
      { nome: m.temaNames[1], qs: t1 },
    ];
    const { temaNames: _t, ...rest } = m;
    return { ...rest, temas };
  });
}

export const FORCAS_DIAGNOSTICO: readonly ForcaDef[] = buildForcas();

export { FLAT_QUESTIONS, FORCAS_META };
